import { createFileRoute } from "@tanstack/react-router";
import OutpatientRehabNearMeNJ from "@/pages/OutpatientRehabNearMeNJ";
import { routeHead } from "@/lib/route-head";

export const Route = createFileRoute("/outpatient-rehab-near-me-nj")({
  head: () => routeHead("/outpatient-rehab-near-me-nj"),
  component: OutpatientRehabNearMeNJ,
});
